import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

const YEAR = new Date().getFullYear();

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="mt-16 border-t border-border bg-background/60 backdrop-blur"
    >
      <div className="max-w-6xl mx-auto px-4 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <div className="w-7 h-7 rounded-md bg-primary flex items-center justify-center text-white text-[10px] font-bold">
            PS
          </div>
          <span>&copy; {YEAR} PDF Studio Pro</span>
        </div>

        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm">
          <Link to="/pricing" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-pricing-link">
            Pricing
          </Link>
          <Link to="/refund-policy" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-refund-link">
            Cancellation &amp; Refund Policy
          </Link>
          <a
            href="mailto:support@pdfstudiopro.co.za"
            className="inline-flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors"
            data-testid="footer-support-link"
          >
            <Mail className="w-3.5 h-3.5" />
            support@pdfstudiopro.co.za
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
